"use client";

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    // Always send to home; Portal entry uses same lifecycle logic (dashboard → correct step)
    router.replace('/home');
  }, [router]);

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="text-lg">Loading...</div>
    </div>
  );
}